module.exports = __webpack_public_path__ + "media/images/responsive/page_common/noimage/square/deco_black-f599a7243b8a9200a56282513da841a1.png";